import { useEffect, useState } from 'react'
import { getSessions } from '../../shared/api'
import { IconFile, IconClose } from '../../shared/assets/icons'

// Date only, no time-of-day
function formatDate(iso) {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString()
}

// Mounted only while open (see App.jsx), so it fetches once per open — freshly-uploaded
// sessions show up each time the panel is reopened.
export default function RecentSessionsPanel({ onClose, onReopen }) {
  const [sessions, setSessions] = useState([])
  const [loading, setLoading]   = useState(true)
  const [error, setError]       = useState(null)

  useEffect(() => {
    const controller = new AbortController()
    getSessions(controller.signal)
      .then(setSessions)
      .catch(e => { if (e.code !== 'ERR_CANCELED') setError(e.message) })
      .finally(() => { if (!controller.signal.aborted) setLoading(false) })
    return () => controller.abort()
  }, [])

  return (
    <div className="recent-panel">
      <div className="recent-header">
        <span className="recent-title">
          <IconFile style={{ marginRight: 5, verticalAlign: 'middle' }} />
          Recent Sessions
          {loading && <span className="spin" style={{ marginLeft: 6, verticalAlign: 'middle' }} />}
        </span>
        <button className="icon-btn" onClick={onClose} title="Close">
          <IconClose />
        </button>
      </div>
      <div className="recent-list">
        {error && <div className="recent-empty">{error}</div>}
        {!error && !loading && sessions.length === 0 && (
          <div className="recent-empty">No recent sessions yet.</div>
        )}
        {sessions.map(s => (
          <button
            key={s.session_id}
            className="recent-row"
            onClick={() => onReopen(s)}
            title={`Reopen ${s.filename || s.filename_base || s.session_id}`}
          >
            <span className="recent-row-name">{s.filename || s.filename_base || s.session_id}</span>
            <span className="recent-row-date">{formatDate(s.created)}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
